import Validator from './Validator';

export default function validateBoostGeneral(form) {
  return Validator.create(form, {
    yearsOfExperience: {
      validators: {
        notEmpty: {
          message: 'Berufserfahrung ist ein Pflichtfeld',
        },
        between: {
          min: 0,
          max: 100,
          message: 'Berufserfahrung muss eine Zahl (zwischen 0 und 100) sein',
        },
      },
    },
    weeklyWorkingHours: {
      validators: {
        notEmpty: {
          message: 'Arbeitszeit ist ein Pflichtfeld',
        },
        between: {
          min: 1,
          max: 168,
          message: 'Arbeitszeit muss eine Zahl (zwischen 1 und 168) sein',
        },
        regexp: {
          regexp: /^(?!0|\.00)[0-9]+(.\d{3})*(,[0-9]{0,2})?$/,
          message: 'Dezimalstellen müssen mit einem Komma getrennt werden (zb. 38,5)',
        },
      },
    },
    educationLevel: {
      validators: {
        notEmpty: {
          message: 'Ausbildung ist ein Pflichtfeld',
        },
      },
    },
    seniority: {
      validators: {
        notEmpty: {
          message: 'Positionsebene ist ein Pflichtfeld',
        },
      },
    },
    salaryIndicationPeriod: {
      validators: {
        notEmpty: {
          message: 'Gehaltsperiode ist ein Pflichtfeld',
        },
      },
    },
    salaryRangeFrom: {
      validators: {
        notEmpty: {
          message: 'Gehaltsangabe ist ein Pflichtfeld',
        },
        regexp: {
          regexp: /^(?!0|\.00)[0-9]+(.\d{3})*(,[0-9]{0,2})?$/,
          flags: 'ig',
          message: 'Gehaltsangabe muss eine Zahl sein (zb. 23.500,70)',
        },
      },
    },
    salaryRangeTo: {
      validators: {
        notEmpty: {
          message: 'Gehaltsangabe ist ein Pflichtfeld',
        },
        regexp: {
          regexp: /^(?!0|\.00)[0-9]+(.\d{3})*(,[0-9]{0,2})?$/,
          flags: 'ig',
          message: 'Gehaltsangabe muss eine Zahl sein (zb. 23.500,70)',
        },
      },
    },
    vonqIndustryId: {
      validators: {
        notEmpty: {
          message: 'Branche ist ein Pflichtfeld',
        },
      },
    },
    vonqJobFunctionId: {
      validators: {
        notEmpty: {
          message: 'Berufsfeld ist ein Pflichtfeld',
        },
      },
    },
  });
}
